"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { ShopProDetailModel } from "@/models/virtual-shop/ShopDetail.model";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
import { Component, Mixins, Ref } from "vue-property-decorator";
import MoreDetail from "./components/MoreDetail.vue";
import OperateLog from "./components/OperateLog.vue";
import AccessLog from "./components/AccessLog.vue";
import BindLog from "./components/BindLog.vue";
import LoginLog from "./components/LoginLog.vue";
let ShopDetail = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.shopId = "";
    this.shopOldId = "";
    this.activityTab = "shop_detail";
    this.shopDetailData = new ShopProDetailModel();
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      this.shopId = String(this.$route.query.id);
      if (this.shopId === "" || this.shopId === null || this.shopId === void 0) {
        this.$router.go(-1);
        return;
      }
      yield this.getShopDetailData(this.shopId);
    });
  }
  getShopDetailData(shopId) {
    return __async(this, null, function* () {
      try {
        const result = yield API.get(`api://base.auth.pro/v1/shops/${shopId}`, {
          params: {
            type: "show"
          }
        });
        this.shopDetailData = result.data;
        this.shopOldId = result.data.oldId;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  toOptions() {
    if (this.activityTab === "login_log") {
      this.$router.push("/options?tab=LoginLogs");
    }
    if (this.activityTab === "access_log") {
      this.$router.push("/options?tab=AccessLogs");
    }
  }
  goBack() {
    this.$router.go(-1);
  }
};
__decorateClass([
  Ref("more-detail")
], ShopDetail.prototype, "_moreDetail", 2);
__decorateClass([
  Ref("operate-log")
], ShopDetail.prototype, "_operateLog", 2);
__decorateClass([
  Ref("access-log")
], ShopDetail.prototype, "_accessLog", 2);
__decorateClass([
  Ref("bind-log")
], ShopDetail.prototype, "_bindLog", 2);
__decorateClass([
  Ref("login-log")
], ShopDetail.prototype, "_loginLog", 2);
ShopDetail = __decorateClass([
  Component({
    components: {
      // DragDialog,
      MoreDetail,
      OperateLog,
      AccessLog,
      BindLog,
      LoginLog
    }
  })
], ShopDetail);
export {
  ShopDetail as default
};
